import { render, staticRenderFns } from "./StoreCard.vue?vue&type=template&id=5d3f237e&scoped=true"
import script from "./StoreCard.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StoreCard.vue?vue&type=style&index=0&id=5d3f237e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3f237e",
  null
  
)

export default component.exports